class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;
    this.scrollHandler = null;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
      announcementSticky: "m-announcement-bar--sticky",
      headerWithAnnouncement: "m-header--with-sticky-announcement",
    };
    this.announcementSection = this.getAnnouncementSection();
    this.init();
  }

  getAnnouncementSection() {
    const announcementBar = document.querySelector("m-announcement-bar");
    if (!announcementBar) return null;

    return (
      announcementBar.closest(".shopify-section-group-header-group") ||
      announcementBar.closest(".shopify-section") ||
      announcementBar.parentElement
    );
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    if (this.stickyHeader === "always") {
      this.classList.add(this.classes.always);
    }
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }

    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = window.scrollY;
    this.scrollHandler = () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.scrollDown, this.classes.stuck);
        if (this.stickyHeader !== "always") {
          this.classList.remove(this.classes.always);
        }
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        lastScroll = currentScroll;
        return;
      }

      const scrollingUp = currentScroll < lastScroll;
      const scrollingDown = currentScroll > lastScroll;

      if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (this.stickyHeader === "on_scroll_up") {
        if (scrollingUp) {
          this.classList.add(this.classes.stuck, this.classes.scrollUp);
          this.classList.remove(this.classes.scrollDown);
          document.body.classList.remove(this.classes.headerScrollDown);
          document.body.classList.add(this.classes.headerScrollUp);
        } else if (scrollingDown && this.classList.contains(this.classes.stuck)) {
          this.classList.remove(this.classes.scrollUp);
          this.classList.add(this.classes.scrollDown);
          document.body.classList.remove(this.classes.headerScrollUp);
          document.body.classList.add(this.classes.headerScrollDown);
        }
      }
      lastScroll = currentScroll;
    };

    window.addEventListener("scroll", this.scrollHandler, { passive: true });
  }
}
customElements.define("m-header", MHeader);
